<template>
  <o-card :enable-back="true" :title="$t('medtastic.impressum')" class="col-lg-12">
    <div class="pb-3" v-html="$t('medtastic.impressum_text')">
    </div>
  </o-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  layout: 'user',
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  }
}
</script>
